import { render, staticRenderFns } from "./DocAccessType.vue?vue&type=template&id=1749e960&"
import script from "./DocAccessType.vue?vue&type=script&lang=js&"
export * from "./DocAccessType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DocAccessType.vue"
export default component.exports